/* eslint-disable */

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from "./routes/__root";
import { Route as VersionRouteImport } from "./routes/$version";
import { Route as IndexRouteImport } from "./routes/index";
import { Route as VersionIndexRouteImport } from "./routes/$version/index";
import { Route as VersionTextsIndexRouteImport } from "./routes/$version/texts/index";
import { Route as VersionDocsIndexRouteImport } from "./routes/$version/docs/index";
import { Route as VersionDefaultContentIndexRouteImport } from "./routes/$version/default-content/index";
import { Route as VersionTextsPageRouteImport } from "./routes/$version/texts/$page";
import { Route as VersionDocsPageRouteImport } from "./routes/$version/docs/$page";
import { Route as VersionDefaultContentPageRouteImport } from "./routes/$version/default-content/$page";

const VersionRoute = VersionRouteImport.update({
  id: "/$version",
  path: "/$version",
  getParentRoute: () => rootRouteImport,
} as any);
const IndexRoute = IndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => rootRouteImport,
} as any);
const VersionIndexRoute = VersionIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => VersionRoute,
} as any);
const VersionTextsIndexRoute = VersionTextsIndexRouteImport.update({
  id: "/texts/",
  path: "/texts/",
  getParentRoute: () => VersionRoute,
} as any);
const VersionDocsIndexRoute = VersionDocsIndexRouteImport.update({
  id: "/docs/",
  path: "/docs/",
  getParentRoute: () => VersionRoute,
} as any);
const VersionDefaultContentIndexRoute =
  VersionDefaultContentIndexRouteImport.update({
    id: "/default-content/",
    path: "/default-content/",
    getParentRoute: () => VersionRoute,
  } as any);
const VersionTextsPageRoute = VersionTextsPageRouteImport.update({
  id: "/texts/$page",
  path: "/texts/$page",
  getParentRoute: () => VersionRoute,
} as any);
const VersionDocsPageRoute = VersionDocsPageRouteImport.update({
  id: "/docs/$page",
  path: "/docs/$page",
  getParentRoute: () => VersionRoute,
} as any);
const VersionDefaultContentPageRoute =
  VersionDefaultContentPageRouteImport.update({
    id: "/default-content/$page",
    path: "/default-content/$page",
    getParentRoute: () => VersionRoute,
  } as any);

export interface FileRoutesByFullPath {
  "/": typeof IndexRoute;
  "/$version": typeof VersionRouteWithChildren;
  "/$version/": typeof VersionIndexRoute;
  "/$version/default-content/$page": typeof VersionDefaultContentPageRoute;
  "/$version/docs/$page": typeof VersionDocsPageRoute;
  "/$version/texts/$page": typeof VersionTextsPageRoute;
  "/$version/default-content/": typeof VersionDefaultContentIndexRoute;
  "/$version/docs/": typeof VersionDocsIndexRoute;
  "/$version/texts/": typeof VersionTextsIndexRoute;
}
export interface FileRoutesByTo {
  "/": typeof IndexRoute;
  "/$version": typeof VersionIndexRoute;
  "/$version/default-content/$page": typeof VersionDefaultContentPageRoute;
  "/$version/docs/$page": typeof VersionDocsPageRoute;
  "/$version/texts/$page": typeof VersionTextsPageRoute;
  "/$version/default-content": typeof VersionDefaultContentIndexRoute;
  "/$version/docs": typeof VersionDocsIndexRoute;
  "/$version/texts": typeof VersionTextsIndexRoute;
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport;
  "/": typeof IndexRoute;
  "/$version": typeof VersionRouteWithChildren;
  "/$version/": typeof VersionIndexRoute;
  "/$version/default-content/$page": typeof VersionDefaultContentPageRoute;
  "/$version/docs/$page": typeof VersionDocsPageRoute;
  "/$version/texts/$page": typeof VersionTextsPageRoute;
  "/$version/default-content/": typeof VersionDefaultContentIndexRoute;
  "/$version/docs/": typeof VersionDocsIndexRoute;
  "/$version/texts/": typeof VersionTextsIndexRoute;
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath;
  fullPaths:
    | "/"
    | "/$version"
    | "/$version/"
    | "/$version/default-content/$page"
    | "/$version/docs/$page"
    | "/$version/texts/$page"
    | "/$version/default-content/"
    | "/$version/docs/"
    | "/$version/texts/";
  fileRoutesByTo: FileRoutesByTo;
  to:
    | "/"
    | "/$version"
    | "/$version/default-content/$page"
    | "/$version/docs/$page"
    | "/$version/texts/$page"
    | "/$version/default-content"
    | "/$version/docs"
    | "/$version/texts";
  id:
    | "__root__"
    | "/"
    | "/$version"
    | "/$version/"
    | "/$version/default-content/$page"
    | "/$version/docs/$page"
    | "/$version/texts/$page"
    | "/$version/default-content/"
    | "/$version/docs/"
    | "/$version/texts/";
  fileRoutesById: FileRoutesById;
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute;
  VersionRoute: typeof VersionRouteWithChildren;
}

declare module "@tanstack/react-router" {
  interface FileRoutesByPath {
    "/$version": {
      id: "/$version";
      path: "/$version";
      fullPath: "/$version";
      preLoaderRoute: typeof VersionRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/": {
      id: "/";
      path: "/";
      fullPath: "/";
      preLoaderRoute: typeof IndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/$version/": {
      id: "/$version/";
      path: "/";
      fullPath: "/$version/";
      preLoaderRoute: typeof VersionIndexRouteImport;
      parentRoute: typeof VersionRoute;
    };
    "/$version/texts/": {
      id: "/$version/texts/";
      path: "/texts";
      fullPath: "/$version/texts/";
      preLoaderRoute: typeof VersionTextsIndexRouteImport;
      parentRoute: typeof VersionRoute;
    };
    "/$version/docs/": {
      id: "/$version/docs/";
      path: "/docs";
      fullPath: "/$version/docs/";
      preLoaderRoute: typeof VersionDocsIndexRouteImport;
      parentRoute: typeof VersionRoute;
    };
    "/$version/default-content/": {
      id: "/$version/default-content/";
      path: "/default-content";
      fullPath: "/$version/default-content/";
      preLoaderRoute: typeof VersionDefaultContentIndexRouteImport;
      parentRoute: typeof VersionRoute;
    };
    "/$version/texts/$page": {
      id: "/$version/texts/$page";
      path: "/texts/$page";
      fullPath: "/$version/texts/$page";
      preLoaderRoute: typeof VersionTextsPageRouteImport;
      parentRoute: typeof VersionRoute;
    };
    "/$version/docs/$page": {
      id: "/$version/docs/$page";
      path: "/docs/$page";
      fullPath: "/$version/docs/$page";
      preLoaderRoute: typeof VersionDocsPageRouteImport;
      parentRoute: typeof VersionRoute;
    };
    "/$version/default-content/$page": {
      id: "/$version/default-content/$page";
      path: "/default-content/$page";
      fullPath: "/$version/default-content/$page";
      preLoaderRoute: typeof VersionDefaultContentPageRouteImport;
      parentRoute: typeof VersionRoute;
    };
  }
}

interface VersionRouteChildren {
  VersionIndexRoute: typeof VersionIndexRoute;
  VersionDefaultContentPageRoute: typeof VersionDefaultContentPageRoute;
  VersionDocsPageRoute: typeof VersionDocsPageRoute;
  VersionTextsPageRoute: typeof VersionTextsPageRoute;
  VersionDefaultContentIndexRoute: typeof VersionDefaultContentIndexRoute;
  VersionDocsIndexRoute: typeof VersionDocsIndexRoute;
  VersionTextsIndexRoute: typeof VersionTextsIndexRoute;
}

const VersionRouteChildren: VersionRouteChildren = {
  VersionIndexRoute: VersionIndexRoute,
  VersionDefaultContentPageRoute: VersionDefaultContentPageRoute,
  VersionDocsPageRoute: VersionDocsPageRoute,
  VersionTextsPageRoute: VersionTextsPageRoute,
  VersionDefaultContentIndexRoute: VersionDefaultContentIndexRoute,
  VersionDocsIndexRoute: VersionDocsIndexRoute,
  VersionTextsIndexRoute: VersionTextsIndexRoute,
};

const VersionRouteWithChildren =
  VersionRoute._addFileChildren(VersionRouteChildren);

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  VersionRoute: VersionRouteWithChildren,
};
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>();
